// ms_MY.js
const ms_MY = {
    "GuanShui": "Cukai impor",
    "ZiZhangHao":"Akaun anak",

    "ZHONGWEN":"Chinese",
    "YINGYU":"English",
    "XIBANYAYU":"Español",
    "DEYU":"Deutsch",
    "FAYU":"Français",
    "ALABOYU":"العربية",
    "EYU":"Русский",
    "MALAIYU":"Bahasa Malaysia",
    "YUENANYU":"Tiếng Việt",
    "TAIYU":"ภาษาไทย",
    "YINNIYU":"Bahasa Indonesia",
    //components
    "ShangeChuanYanZhengTuPian": "Muat Naik Gambar Pengesahan",
    "ChuanHaoYanZheng": "Pengesahan IMEI",
    "YanZhengChuanHao": "Sahkan IMEI",
    "Ci": "kali",
    "DingDanMan": "Pesanan penuh",
    "YuanZeng": "RM hadiah",
    "SCFJ_ZD4Z_DZBCG": "Muat naik lampiran, maks 4 imej, setiap ≤3MB",
    //ChatRoom
    "ZBZCBQFH": "Emoji tidak disokong",
    "FaSongLianJie": "Hantar pautan",
    "YiChangXiaoXi": "Mesej tidak normal",
    "QingShuRu": "Sila masukkan",
    "FaSong": "Hantar",
    //DateSelector
    "DQSJXYKSSJ": "Masa semasa lebih awal dari masa mula",
    "DQSJCGJSSJ": "Masa semasa melebihi masa tamat",
    "QuXiao": "Batal",
    "NianYueRi": "Tahun-Bulan-Hari",
    "ShiFen": "Jam-Minit",
    "QueDing": "Sahkan",
    "Nian": "Tahun",
    "Yue": "Bulan",
    "Ri": "Hari",
    "Shi": "Jam",
    "Fen": "Minit",
    //goods-list-card
    "Qi": "dari",
    //goods-promotion
    "1GeCuXiao": "{num} promosi",
    "ChaKanZengPin": "Lihat hadiah",
    "JHDJSHS_1T": "Baki masa: {d}H {h}J {m}M {s}S",
    "YHGZ_ZPBKD": "Peraturan: Hadiah tidak boleh digabungkan",
    "YHGZ_AZZGM": "Peraturan: Diskaun berdasarkan kuantiti akhir",
    "GuanBi": "Tutup",
    "Man1Song1": "Beli {mai} dapat {song} percuma",
    //group-filtrate
    "QuanBu": "Semua",
    "ZWXGSJ": "Tiada data berkaitan",
    "ZuiDiJia": "Harga terendah",
    "ZuiGaoJia": "Harga tertinggi",
    "LeiXing": "Jenis",
    "PinPai": "Jenama",
    "BiaoQian": "Tag",
    "JiaGeQuJian": "Julat harga",
    "SPMC_GG_BH_": "Nama produk / Spesifikasi / ID / Huruf awal",
    "SPMC_GG_BH_G": "Nama produk / Spesifikasi / ID",
    "ZuHeShaiXuan": "Penapisan gabungan",
    "ChongZhi_CanShu": "Tetap semula",
    //image-upload
    "ZDKSC1ZTP": "Maks 1 imej",
    "ZYXSCTP": "Hanya imej dibenarkan",
    "SCTPDXBYXC": "Saiz imej ≤5MB",
    "QBYCFSCTP_": "Tiada muat naik berganda",
    "ShangChuanChengGong": "Muat naik berjaya",
    "ZDKSC1Z": "Maks 1",
    //keyboard
    "CCSLZDXZ": "Melebihi had",
    "QiDingLiang": "Kuantiti minimum",
    "ShouQi": "Tutup",
    "ShanChu": "Padam",
    //MultiPicker
    "FanHui": "Kembali",
    //order-cart
    "Dai": "Ejen",
    "YiQuXiao": "Dibatalkan",
    "ZengPin": "Hadiah",
    "1Zhong": "{num} jenis",
    "1Jian": "{num} unit",
    "HeJi": "Jumlah",
    "DaiFu": "Menunggu pembayaran",
    //order-promotion
    "_DDM1YZ1J_": "[Beli {target} dapat {name}x{number}]",
    "_DDM1YLJ1Y_": "[Beli {m} jimat {n}]",
    "_DDM1YLX1Z_": "[Beli {m} dapat {n}% diskaun]",
    "DingDanCuXiao": "Promosi pesanan",
    //page-ad
    "DLCKJG": "Log masuk untuk lihat harga",
    //page-floating
    "DianPuZhuYe": "Laman utama kedai",
    "GouWuChe": "Troli",
    "ZaiXianKeFu": "Khidmat pelanggan",
    "GeRenZhongXin": "Profil",
    "LianXiDianHua": "Hubungi",
    "FanHuiDingBu": "Kembali ke atas",
    //page-null
    "ZBDYML": "Halaman tidak dijumpai",
    "KNWZCW_HZY": "URL salah atau halaman dipadam",
    "FanHuiShangJi": "Kembali",
    "FanHuiShouYe": "Ke laman utama",
    //product-edit
    "SPQDBNWK": "Senarai produk tidak boleh kosong",
    "WoZhiDaoLe": "Saya faham",
    "SFQRSCSP": "Sahkan padam produk?",
    "QueRen": "Sahkan",
    "ZYXSRSZBQB": "Hanya nombor, maks 2 perpuluhan",
    "ShangPinDanJia": "Harga unit",
    "YSPYJ": "Harga asal",
    "QSRZDJG": "Masukkan harga ditetapkan",
    "ShuLiang": "Kuantiti",
    "DanWei": "Unit",
    "DanJia": "Harga",
    "BeiZhu": "Catatan",
    "YiChuShangPin": "Alih keluar produk",
    "XiuGai": "Edit",
    //yunshl
    "TPSLCCYXSZ": "Bilangan imej melebihi had!",
    "WJBDDY5M_QC": "Fail ≤5MB, sila pilih semula",
    "TPSCWC": "Muat naik imej selesai",
    //BusinessFilter
    "_DGSLM1Z1_": "[Pesan {target} dapat {provide}]",
    "_M1JLXMJ1Y_": "[Beli {target} jimat {cut_money_}/unit]",
    "_DHJJZ1Y_": "[Harga turun ke {cuted_price_}]",
    "_M1JLXMJ1Z_": "[Beli {target} dapat {cut_percent_}% diskaun/unit]",
    "_YDHJD1Z_": "[Harga asal {cuted_percent_}% diskaun]",
    "YuJiKaiShiFaHuo": "Jangkaan penghantaran: {date}",
    "YuJi": "Dijangka",
    "MMYDDR": "BB/HH",
    "KaiShiFaHuo": "Mula penghantaran",
    "_M1LXM1Y_": "[Beli 1 jimat 1/unit]",
    "_M1LXM1Z_": "[Beli 1 dapat 1% diskaun/unit]",
    "DaiQueRen": "Menunggu pengesahan",
    "DaiFaHuo": "Menunggu penghantaran",
    "DaiShouHuo": "Menunggu penerimaan",
    "YiWanCheng": "Selesai",
    "DaiFuKuan": "Menunggu pembayaran",
    "YiFuKuan": "Telah dibayar",
    "YiZuoFei": "Dibatalkan",
    "DaiShenHe": "Menunggu semakan",
    "DaiHeXiao": "Menunggu pengesahan",
    "YiHeXiao": "Telah disahkan",
    "XianXiaZhiFu": "Pembayaran offline",
    "ZhiNengDaoZhangShiBie": "Pemindahan bank (pengesahan automatik)",
    "WeiXinZhiFu": "WeChat Pay",
    "KQ-WeiXinZhiFu": "99Bill (WeChat)",
    "KQ-ZFBZF": "99Bill (Alipay)",
    "KQZhiFu": "99Bill Pay",
    "ZFBZF": "Alipay",
    "YuEZhiFu": "Bayar dengan baki",
    "HuoDaoFuKuan": "Bayar upon delivery",
    "DaiTuiHuo": "Menunggu pulangan",
    "DaiTuiKuan": "Menunggu bayaran balik",
    "ChuangJianDingDan": "Buat pesanan",
    "BianJiDingDan": "Edit pesanan",
    "TiJiaoDingDan": "Hantar pesanan",
    "DingDanShenHe": "Semak pesanan",
    "CaiWuShenHe": "Semak kewangan",
    "BoHui": "Tolak",
    "TianJiaShouKuan": "Tambah pembayaran",
    "ZaiXianZhiFu": "Pembayaran online",
    "ShouKuanShenHe": "Semak pembayaran",
    "ShouKuanZuoFei": "Batalkan pembayaran",
    "ChuKu": "Keluar stok",
    "ChuKuShenHe": "Semak keluar stok",
    "FaHuo": "Hantar",
    "TianJiaWuLiu": "Tambah logistik",
    "XiuGaiWuLiu": "Edit logistik",
    "ChuKuZuoFei": "Batalkan keluar stok",
    "ShouHuo": "Terima",
    "DingDanHeZhun": "Pesanan diluluskan",
    "QuXiaoDingDan": "Batal pesanan",
    "CJTHD": "Buat pulangan",
    "DaYin": "Cetak",
    "DaoChu": "Eksport",
    "DingDanWanCheng": "Pesanan selesai",
    "QiangZhiWanCheng": "Selesai paksa",
    "DingDanZuoFei": "Batalkan pesanan",
    "MaiZeng": "Beli dapat hadiah",
    "ZhiJiang": "Diskaun terus",
    "DaZhe": "Diskaun",
    "YuShou": "Pra-pesanan",
    "DingDanManZeng": "Hadiah pesanan penuh",
    "DingDanManJian": "Diskaun pesanan penuh",
    "DingDanManZhe": "Diskaun % pesanan penuh",
    "XinRenQuan": "Kupon pengguna baru",
    "ManJianQuan": "Kupon diskaun",
    "ShangPinQuan": "Kupon produk",
    "DaiJieSuan": "Menunggu penyelesaian",
    "YiJieSuan": "Telah diselesaikan",
    "QuanBuShangPin": "Semua produk",
    "TuiJianShangPin": "Produk disyorkan",
    "XinPin": "Baru",
    "ReXiaoShangPin": "Popular",
    "ChangYongShangPin": "Kerap dibeli",
    //BusinessUtil
    "DaiShouKuan": "Menunggu pembayaran",
    "BuFenShouKuan": "Pembayaran separa",
    "YiShouKuan": "Telah dibayar",
    "BXYFP": "Tiada invois diperlukan",
    "ZZSPTFP": "Invois VAT biasa",
    "ZZSZYFP": "Invois VAT khas",
    "QiTaFaPiao": "Invois lain",
    "XianXia": "Offline",
    "WeiXin": "WeChat",
    "ZhiFuBao": "Alipay",
    "YuCunKuan": "Deposit",
    "XianXiaZhuangZhang": "Pemindahan bank",
    "XianShangZhiFu": "Pembayaran online (WeChat/Alipay/JD/UnionPay)",
    "YCKZF": "Bayar dengan baki",
    "DaiTiJiao": "Menunggu penghantaran",
    "KuaiDi": "Kurier",
    "SongHuoShangMen": "Penghantaran",
    "ShangMenZiQu": "Ambil sendiri",
    "WuLiuHuoYun": "Pengangkutan kargo",
    "QiTa": "Lain-lain",
    //check-util
    "QSRBXY6WDM": "Kata laluan ≥6 aksara",
    "QSRBDY20WDM": "Kata laluan ≤20 aksara",
    "MMGSCW": "Format kata laluan salah",
    //common-utils
    "SJCW_QLXKF": "Ralat data, hubungi sokongan",
    "ZBZCQD": "Daftar masuk tidak disokong",
    "HuJiao": "Panggil",
    "DLZHBCZ": "Akaun tidak wujud",
    "QLXGLYKT": "Hubungi admin untuk aktifkan",
    "GQYZHBJY": "Akaun syarikat dinyahaktifkan",
    "QLXYSDH": "Hubungi YUNSHANG",
    "GQYZHSYQJS": "Tempoh percubaan tamat",
    "GQYZHYGQL": "Akaun tamat tempoh",
    "XYXFCNSY": "Perlu diperbaharui",
    "GQYBCZCZH": "Akaun syarikat tidak sah",
    "NDDHZHYBQY": "Akaun anda dinyahaktifkan oleh syarikat",
    "NYBSQY1DHZ": "Bukan lagi rakan kongsi",
    "NDDPYBTY_B": "Kedai digantung",
    "GZHWKTDSZB": "Modul lampu tidak diaktifkan",
    "WXSQYZYGQ": "Pengesahan WeChat tamat tempoh",
    "WXSQSB": "Pengesahan WeChat gagal",
    "WXSQSB_CWX": "Pengesahan WeChat gagal: {msg}",
    "DengLuGuoQi": "Sesi tamat tempoh",
    "DLGQ_QCXDL": "Sesi tamat, sila log masuk semula",
    //data-constant
    "ShangJia": "Dijual",
    "YiXiaJia": "Tidak dijual",
    "YiJinYong": "Dinyahaktifkan",
    "YiQiYong": "Diaktifkan",
    "YiTingYong": "Digantung",
    "KeHuZhuCe": "Pelanggan berdaftar",
    "XinZengDaoRu": "Diimport",
    "DDDSH": "Menunggu semakan pesanan",
    "DCWSH": "Menunggu semakan kewangan",
    "DaiChuKu": "Menunggu keluar stok",
    "DCK_BF_": "Menunggu keluar stok (separa)",
    "DFH_BF_": "Menunggu penghantaran (separa)",
    "DSH_BF_": "Menunggu penerimaan (separa)",
    "DSK_BF_": "Menunggu pembayaran (separa)",
    "WTHSQ": "Tiada permintaan pulangan",
    "THDSH": "Pulangan menunggu semakan",
    "THCLZ": "Pemprosesan pulangan",
    "THYWC": "Pulangan selesai",
    "DYDHD": "Cetak pesanan",
    "DYFHD": "Cetak invois",
    "DCDHD": "Eksport pesanan",
    "DCFHDWE_P": "Eksport sebagai Excel/PDF",
    "TuiDanZuoFei": "Pulangan dibatalkan",
    "DTHSH": "Menunggu semakan pulangan",
    "DaiRuKu": "Menunggu masuk stok",
    "DRK_BF_": "Menunggu masuk stok (separa)",
    "DFK_BF_": "Menunggu pembayaran (separa)",
    "ChuangJianTuiDan": "Buat pulangan",
    "BianJiTuiDan": "Edit pulangan",
    "TiJiaoTuiDan": "Hantar pulangan",
    "TuiHuoShenHe": "Semak pulangan",
    "RuKu": "Masuk stok",
    "RuKuShenHe": "Semak masuk stok",
    "RuKuZuoFei": "Batalkan masuk stok",
    "TianJiaFuKuan": "Tambah pembayaran",
    "FuKuanZuoFei": "Batalkan pembayaran",
    "FuKuanShenHe": "Semak pembayaran",
    "TuiDanWanCheng": "Pulangan selesai",
    "QiTaChuKu": "Keluar stok lain",
    "XiaoShouChuKu": "Keluar stok jualan",
    "PanKuiChuKu": "Keluar stok kerugian",
    "DiaoBoChuKu": "Keluar stok pindahan",
    "CaiGouTuiHuo": "Pulangan pembelian",
    "TuiHuoRuKu": "Masuk stok pulangan",
    "CaiGouRuKu": "Masuk stok pembelian",
    "QiTaRuKu": "Masuk stok lain",
    "PanYingRuKu": "Masuk stok keuntungan",
    "DiaoBoRuKu": "Masuk stok pindahan",
    "CJCGD": "Buat pesanan pembelian",
    "BJCGD": "Edit pesanan pembelian",
    "TJCGD": "Hantar pesanan pembelian",
    "CGDZF": "Batalkan pesanan pembelian",
    "CGDWC": "Pesanan pembelian selesai",
    "CGTHZF": "Batalkan pulangan pembelian",
    "CGTHWC": "Pulangan pembelian selesai",
    "THDDY": "Cetak pulangan",
    "THDDC": "Eksport pulangan",
    "CKDDY": "Cetak keluar stok",
    "CKDDC": "Eksport keluar stok",
    "GLDZH": "Akaun pentadbiran",
    "DHDZH": "Akaun pesanan",
    "ShenHeTongGuo": "Diluluskan",
    "SHBTG": "Ditolak",
    "WuXuFaPiao": "Tiada invois diperlukan",
    "DaiKeXiaDan": "Pesanan oleh ejen",
    "ZiZhuXiaDan": "Pesanan sendiri",
    "PCShangCheng": "PC Mall",
    "APPShangCheng": "APP Mall",
    "TVShangCheng": "TV Mall",
    "WeiXinShangCheng": "WeChat Mall",
    "ShouJiShangCheng": "Mobile Mall",
    "ADDXSMLTC": "Komisen keuntungan jualan",
    "ADDXSSRTC": "Komisen hasil jualan",
    "AKHSSYG": "Mengikut wakil jualan",
    "AnZhiDanRen": "Mengikut pencipta",
    "ATHJEBLKCT": "Tolak komisen berdasarkan nilai pulangan",
    "DDYTHBJXTC": "Tiada komisen untuk pesanan pulangan",
    "DaiDaKuan": "Menunggu pembayaran",
    "WeiKaiShi": "Belum bermula",
    "JinXingZhong": "Sedang berjalan",
    "YiGuoQi": "Tamat tempoh",
    //Utils.js
    "YouHuo": "Ada stok",
    "WuHuo": "Tiada stok",
    "Yi": "Bilion",
    "QianWan": "10 Juta",
    "BaiWan": "Juta",
    "Wan": "Ribu",
    "Sheng1Tian": "Tinggal 1 hari",
    "Sheng1XiaoShi": "Tinggal 1 jam",
    "Miao": "Saat",
    "1Miao": "1 saat",
    "GangGang": "Baru sahaja",
    "1FenZhongQian": "1 minit lalu",
    "1XiaoShiQian": "1 jam lalu",
    "1TianQian": "1 hari lalu",
    "1GeYueQian": "1 bulan lalu",
    "1NianQian": "1 tahun lalu",
    "WeiZhiLeiXing": "Jenis tidak diketahui",
    //WechatUtil
    "YYGBCDSP_K": "Lihat produk hebat ini!",
    "ZanWeiSheZhi": "Belum ditetapkan",
    //app
    "HQWXSQXX": "Dapatkan maklumat pengesahan WeChat",
    //flexible
    "JGJYYDMBQ": "Skala berdasarkan tag meta",
    //index
    "NLJZZ": "Memuatkan...",
    "": "routes",
    "ShangPinMingXi": "Butiran produk",
    "ShangPinLeiBie": "Kategori",
    "QXZFPNR": "Sila pilih kandungan invois",
    "QXZFPLX": "Sila pilih jenis invois",
    "QTXFPTT": "Sila masukkan tajuk invois",
    "FaPiaoTaiTou": "Tajuk invois",
    "NSRSBH": "No. Pengenalan Cukai",
    "FaPiaoNeiRong": "Kandungan invois",
    "FaPiaoXinXi": "Maklumat invois",
    "KaiJuFaPiao": "Keluarkan invois",
    "FaPiaoLeiXing": "Jenis invois",
    "Han": "Termasuk",
    "WeiHan": "Tidak termasuk",
    "Shui": "Cukai",
    "QSRFPTT": "Sila masukkan tajuk invois",
    "QSRNSRSBH": "Sila masukkan No. Pengenalan Cukai",
    //routes
    //cart-bill
    "YiManZu_Man": "Telah memenuhi [min",
    "ZaiGou": "Beli lagi",
    "YMZ_DHJJZ": "Telah memenuhi [Harga pesanan turun ke",
    "JianJiangZhi": "unit turun ke",
    "YMZ_YDHJD": "Telah memenuhi [Harga asal diskaun",
    "JianMeiJian": "unit setiap",
    "SYTCSLW0_WFJRGWC": "Stok pakej habis, tidak boleh ditambah ke troli",
    "QingXuanXeShangPin": "Sila pilih produk!",
    "GSPYXJ": "Produk ini tidak dijual lagi!",
    "ZJ2TN": "{day} hari lepas",
    "QDQCXJSP": "Sahkan padam produk tidak dijual?",
    "QingChuChengGong": "Berjaya dipadam",
    "TCSPBKJRGWC_QQXTCSPZYRGW": "Produk pakej tidak boleh ditambah ke troli!",
    "SPSLBN": "Kuantiti produk tidak boleh",
    "TaoCanHan": "Pakej termasuk",
    "TaoCan": "Pakej",
    "QHDSL": "Sahkan kuantiti",
    "SPSLBNDY": "Kuantiti produk tidak boleh kurang dari",
    "XianDingLiang": "Had pesanan",
    "YiRuShouCang": "Tambah ke kegemaran",
    "QuanXuan": "Pilih semua",
    "JianZeng": "hadiah percuma",
    "JianLiXiang_Man": "unit nikmati [min",
    "Yuan_": "RM]",
    "Zhe_": "% diskaun]",
    "KCBZ_WFJRGWC": "Stok tidak cukup, tidak boleh ditambah",
    "XDJEDYDY": "Nilai pesanan ≥",
    "WYXJHYSXDSP": "Tiada produk tidak dijual!",
    "DYQDL": "Bawah kuantiti minimum",
    "ZSPG1J": "{count} jenis produk, jumlah {number} unit",
    "WanCheng": "Selesai",
    "BianJi": "Edit",
    "You": "Ada",
    "ZSPBFHYQ_W": "jenis produk tidak memenuhi syarat",
    "SPSLBNGY": "Kuantiti produk tidak boleh melebihi",
    "JXDJ_CKXYGBFHYQSP": "Lanjutkan untuk lihat produk seterusnya",
    "XiaDan": "Buat pesanan",
    "JianJiang": "unit turun",
    "QRYCSP": "Sahkan alih keluar produk?",
    "QXZXDSP": "Sila pilih produk untuk dipesan",
    "KCBZ_QCXXZ": "Stok tidak cukup, sila pilih semula!",
    "KuCun": "Stok",
    "YCKXD": "RM diperlukan untuk pesanan",
    "QDSCSP": "Sahkan simpan produk?",
    "ShouCangChengGong": "Berjaya disimpan",
    "GYXDL": "Melebihi had pesanan",
    "LiSheng": "Jimat",
    "GWCHSKD_QGYGB": "Troli masih kosong, pergi beli-belah",
    "QuGuangGuang": "Pergi beli-belah",
    "QCXJSP": "Padam produk tidak dijual",
    "ZongE": "Jumlah",
    "YouHui": "Diskaun",
    //cart-list
    "QXZJHRQ": "Sila pilih masa penghantaran",
    "FuJiaFeiYong": "Bayaran tambahan",
    "ZhongShangPin_Gong": "jenis produk, jumlah",
    "PeiSongShiJian": "Masa penghantaran",
    "QXZPSSJ": "Sila pilih masa penghantaran",
    "DingDanJinE": "Jumlah pesanan",
    "SCFJ_ZD4Z": "Muat naik lampiran, maks 4 imej, setiap ≤3MB",
    "KeYongShangPin": "Produk tersedia",
    "ShiYongShuoMing": "Arahan penggunaan",
    "YouXiaoQi": "Tempoh sah",
    "Man": "Min",
    "BZZBZCTSFH": "Catatan tidak menyokong aksara khas",
    "QingXuanZe": "Sila pilih",
    "KaiPiaoXuJia": "Bayaran invois",
    "GeDian": "mata",
    "KPXJ1GD": "Bayaran invois {num} mata",
    "PeiSongFangShi": "Kaedah penghantaran",
    "ShangPinZongJia": "Jumlah produk",
    "YouHuiQuan": "Kupon",
    "ZhangKeXan": "boleh dipilih",
    "DDJEWMZ": "Jumlah pesanan tidak memenuhi",
    "WDYHQ": "Kupon saya",
    "KYYHQ": "Kupon tersedia",
    "YuanKeYong": "RM tersedia",
    "ChaKanDingDan": "Lihat pesanan",
    "ShangPinHanShui": "Produk termasuk cukai",
    "SPWHS": "Produk tidak termasuk cukai",
    "QueRenDingDan": "Sahkan pesanan",
    "XZSHDZ": "Tambah alamat baru",
    "ShangPinQingDan": "Senarai produk",
    "WKYYHQ": "Tiada kupon tersedia",
    "HuChi": "Eksklusif",
    "DaiJinQuan": "Voucher",
    "YunFei": "Kos penghantaran",
    "ShuiFei": "Cukai",
    "BKYYY": "Sebab tidak tersedia",
    "YHQYGQ": "Kupon tamat tempoh",
    "WDYHQSYSJ": "Belum sampai masa penggunaan",
    "ZDSPJEWMZ": "Nilai produk tidak memenuhi",
    "BKYYHQ": "Kupon tidak tersedia",
    "YMZ_MYZJ_": "Telah memenuhi [min {m}RM hadiah {n}unit]",
    "YMZ_MZ": "Telah memenuhi [min {m}RM hadiah {n}]",
    "ZG222YX_M1000": "Beli lagi {money}RM nikmati [min {target}RM hadiah {num}unit]",
    "ZG2JX_MZ": "Beli lagi {num}unit nikmati [min {target}RM hadiah {present}]",
    "YMZ_MYJY_": "Telah memenuhi [min {m}RM jimat {n}RM]",
    "ZGYX_MYJY_": "Beli lagi {m}RM nikmati [min {n}RM jimat {o}RM]",
    "YMZ_MYZ_": "Telah memenuhi [min {m}RM {n}% diskaun]",
    "ZGYX_MYZ_": "Beli lagi {m}RM nikmati [min {n}RM {o}% diskaun]",
    //cart-presale-order
    "QXZPSFS": "Sila pilih kaedah penghantaran",
    "1ZSP_G": "1 jenis produk, jumlah",
    "YSSP_YJ": "Pra-pesanan, dijangkakan",
    "JiaoHuoRiQi": "Tarikh penghantaran",
    "GMJLY": "Tinggalkan mesej",
    //scan-to-cart
    "ZhengZaiChuLi...": "Memproses...",
    "FSCSP": "Bukan produk kedai",
    "ZZCLTXM": "Memproses kod bar...",
    "SPTJCG": "Produk berjaya ditambah",
    "QSTXM": "Sila imbas kod bar",
    "SFSCDQSP": "Padam produk semasa?",
    "BQ_ZBDXGSP": "Maaf, produk tidak dijumpai",
    "XuanZeDanWei": "Pilih unit",
    "JRGWC": "Tambah ke troli",
    "QXXZDJRSP": "Sila pilih produk terlebih dahulu",
    "ZhengZaiChuLi": "Memproses",
    "JRGWCCG": "Berjaya ditambah ke troli",
    "ZanWuShangPin": "Tiada produk",
    //earn-brokerage-share
    "XTYJBNFZSP": "Sistem telah menyalin pautan produk!",
    "NKYHDDYDYJ": "Anda dapat komisen. Lihat dalam \"Saya",
    "LiChaKan": "\"",
    "WeiXinHaoYou": "Rakan WeChat",
    "ErWeiMa": "Kod QR",
    "CASBEWM": "Imbas kod QR",
    "FZSB_QCXFZ": "Salin gagal, cuba lagi!",
    "TWEWM": "Kod QR teks+imej",
    "BCDXC": "Simpan ke galeri",
    "CATPBCDXC": "Tekan lama untuk simpan",
    "FuZhiLianJie": "Salin pautan",
    "FXZYJ": "Kongsi dapat komisen",
    "YJZGKZQYJ": "Anggaran komisen maksimum",
    "PYTGNFXDYMCGGMH": "Apabila rakan beli melalui pautan anda, anda dapat komisen",
    //goods-share
    "FXSPGLSKH": "Kongsi produk dengan pelanggan",
    "FXHJSCNZSD": "Kongsi untuk buat kedai mudah alih peribadi",
    "WSCDQJG_ND": "Harga kedai mudah alih: Harga anda ×",
    "DaiSheZhi": "Belum ditetapkan",
    "PengYouQuan": "Moment",
    "GGFXSZ": "Ubah tetapan kongsi",
    //wechat-login
    "QXSRZH": "Sila masukkan akaun",
    "MMGSCW_6_20W": "Format kata laluan salah (6-20 aksara)",
    "BDYYZH": "Ikut akaun sedia ada",
    "WXKJDL": "Log masuk pantas WeChat",
    "BangDingZhangHao": "Ikut akaun",
    "YYZH_QDL": "Ada akaun? Log masuk",
    "ZCXZH": "Daftar akaun baru",
    "HuanYingNi": "Selamat datang",
    "ZH_SJHM": "Akaun/No. telefon",
    "MiMa": "Kata laluan",
    "QDLHCZ": "Sila log masuk untuk operasi",
    //add-to-cart
    "KCBZ_BNTJG": "Stok tidak cukup, tidak boleh tambah lagi",
    //combined-pay-online
    "ZhiFuChengGong": "Pembayaran berjaya!",
    "ZFSB_QCXCS": "Pembayaran gagal, cuba lagi!",
    "QXXZGG": "Sila pilih spesifikasi dahulu",
    "SXGGX": "Spesifikasi pilihan perlu",
    "GMSLXYQDL_": "Kuantiti bawah minimum, sila beli semula!",
    "GMSLDYXDL_": "Kuantiti melebihi had, sila beli semula!",
    "ShangPinBianHao": "No. produk",
    "QiDing": "Minimum",
    "SXGGDGSLBK": "Kuantiti tidak boleh melebihi",
    "KCBZ_BNTJ": "Stok tidak cukup, tidak boleh tambah",
    "QXXZSP": "Sila pilih produk dahulu",
    "SLBNW0": "Kuantiti tidak boleh 0",
    "QXZGG": "Sila pilih spesifikasi",
    "LiJiYuDing": "Pra-pesanan segera",
    //nav
    "ShouYe": "Laman utama",
    "ShangPin": "Produk",
    "DingDan": "Pesanan",
    "WoDe": "Saya",
    //pay-online
    "ZhiFuQuXiao": "Pembayaran dibatalkan",
    //account-log
    "ShangPinYongJin": "Komisen produk",
    "YaoQingJiangLi": "Hadiah jemputan",
    "TiXian": "Keluarkan",
    "TiXianBoHui": "Keluaran ditolak",
    "ZhuanWeiYuE": "Tukar ke baki",
    "Jin7Tian": "7 hari lepas",
    "Jin30Tian": "30 hari lepas",
    "ShouZhiMingXi": "Butiran transaksi",
    "ZanWuShuJu": "Tiada data",
    //client-statistics
    "WoDeKeHu": "Pelanggan saya",
    "WoDeYaoQing": "Jemputan saya",
    //distribution-home
    "LeiJiKeHu": "Jumlah pelanggan",
    "LeiJiDingDan": "Jumlah pesanan",
    "YaoQingHaoYou": "Jemput rakan",
    "LeiJiYaoQing": "Jumlah jemputan",
    "LJSY_Y_": "Jumlah pendapatan (RM)",
    "BHDJS": "Termasuk menunggu penyelesaian",
    "J7TSY_Y_": "Pendapatan 7 hari (RM)",
    "J7TXZKH_R_": "Pelanggan baru 7 hari (orang)",
    "KTXYJ": "Komisen boleh dikeluarkan",
    "XYJYO": "Perlu usaha lagi",
    "ChangJianWenTi": "Soalan lazim",
    "Q_ZMYJX_TG": "Q: Bagaimana \"promosi dapat komisen\"",
    "A_FXDPND_Z_": "A: Kongsi pautan dengan ikon \"dapat\"",
    "Q_RHJS_TGZ": "Q: Bagaimana komisen dikira?",
    "A_MGD_Z_TBD": "A: Setiap produk ada kadar komisen",
    "Q_TGZQ_DSY": "Q: Bila komisen diterima?",
    "A_HYTGNDFX": "A: Selepas pelanggan sahkan penerimaan",
    "Q_LJKH_LJY": "Q: Mengapa tiada avatar?",
    "A_WXYQZYGZ": "A: Perlu ikuti akaun perkhidmatan",
    "Q_WSMWASSG": "Q: Mengapa tiada komisen?",
	"A_1_HYKNBW": "A：1、好友可能并未与你建立客户关系（好友点击了其他销售员的链接进行注册或下单了）2、好友若在微信环境外（如手机默认浏览器）打开你的分享链接，若浏览器未开启cookie，也将无法记录客户关系，即无法记录推广订单3、上述都没问题时仍然没有记录推广订单，请联系工作人员",
    "XiaoShouZhongXin": "Pusat jualan",
    //generalize-goods
    "SPMC_GG_BH": "Nama produk / Spesifikasi / No.",
    "YuJiZhuan": "Anggaran komisen",
    //invitation-home
    "YaoQingKa": "Kad jemputan",
    "YNYQJR_TGY": "Jemput sertai, promosi dapat hadiah",
    "DJBCDXC": "Klik simpan ke galeri",
    "JYQKFSGHY_": "Kongsi kad dengan rakan",
    //join-home
    "HuanYingJiaRu": "Selamat menyertai",
    "YQNCW": "Jemput anda menjadi",
    "LiJiJiaRu": "Sertai segera",
    //order-statistics
    "YuJiYongJin": "Anggaran komisen",
    "YongJin": "Komisen",
    "YuJiJiangLi": "Anggaran hadiah",
    "JiangLi": "Hadiah",
    "SPTGDD": "Pesanan promosi produk",
    "YQJLDD": "Pesanan hadiah jemputan",
    //performance-statistics
    "YeJiTongJi": "Statistik prestasi",
    "LJKH_R_": "Jumlah pelanggan (orang)",
    "SPYJ_Y_": "Komisen produk (RM)",
    "HanDaiJieSuan": "Termasuk menunggu penyelesaian",
    "XGMCJS": "Takrifan istilah",
    "KeHu": "Pelanggan",
    "HFXYBDLKHG": "Pelanggan yang dihubungkan",
    "YaoQing": "Jemputan",
    "FXYCGYQDXJ": "Ejen jemputan berjaya",
    "FXYTJKHGMH": "Komisen dari pelanggan jemputan",
    "XJFXYTGSPH": "Hadiah dari ejen jemputan",
    //posters-promoting
    "NiCheng": "Nama samaran",
    "HaiBaoTuiGuang": "Poster promosi",
    "JHBFSGHY_T": "Kongsi poster dengan rakan",
    //settlement-home
    "JieSuanZhongXin": "Pusat penyelesaian",
    "KTXJE": "Jumlah boleh dikeluarkan",
    "TiXianJiLu": "Rekod pengeluaran",
    //withdraw-account
    "KHRXMBNWK": "Nama pemegang akaun diperlukan!",
    "KHHBNWK": "Bank diperlukan!",
    "YHKHBNWK": "No. akaun diperlukan!",
    "SFZTPBNWK": "Gambar kad pengenalan diperlukan!",
    "YHKTPBNWK": "Gambar kad bank diperlukan!",
    "BaoCunChengGong": "Berjaya disimpan!",
    "SCSFZ": "Muat naik kad pengenalan",
    "SCYHK": "Muat naik kad bank",
    "BaoCun": "Simpan",
    "TiXianZhangHu": "Akaun pengeluaran",
    "TS_QTXZSXX": "Sila beri maklumat sebenar",
    "KHRXM": "Nama pemegang akaun",
    "KaiHuHang": "Bank",
    "YinhangKaHao": "No. akaun",
    "QSRZSXM": "Sila masukkan nama sebenar",
    "QSRKHHMC": "Sila masukkan nama bank",
    "QSRYHKH": "Sila masukkan no. akaun",
    //withdraw-deposit
    "QXSZTXZH": "Sila tetapkan akaun pengeluaran dahulu",
    "QuSheZhi": "Tetapkan",
    "JEXY10Y_BKT": "Jumlah bawah RM10, tidak boleh dikeluarkan!",
    "JECGKTXJE": "Jumlah melebihi had pengeluaran!",
    "CGDRKTXSX_": "Melebihi had harian (RM20000)!",
    "QueDingJiang": "Sahkan tukar",
    "ZhuanDaoYuE": "ke baki?",
    "_JEDY10YSB": "1. Jumlah bawah RM10 tidak boleh dikeluarkan",
    "_BCTXDZSJ": "2. Masa terima: 5 hari bekerja",
    "_GBSRWHSS": "3. Pendapatan ini termasuk cukai",
    "_ZDYEKYYS": "4. Baki boleh digunakan untuk beli-belah",
    "TXSQCG_QDD": "Permohonan pengeluaran berjaya, tunggu semakan",
    "JEDYKTXJE_": "Jumlah melebihi baki, tidak boleh tukar!",
    "ZZYECG_QDG": "Tukar ke baki berjaya, lihat dalam profil",
    "BenCiTiXian": "Pengeluaran ini",
    "ZhuangDaoYuE": "Tukar ke baki",
    "TiXianDao": "Keluarkan ke",
    "JEW0BKZZYE": "Jumlah 0 tidak boleh tukar",
    "DRTXSX2WY": "Had harian RM20000",
    "QuanBuTiXian": "Keluarkan semua",
    "QueRenTiXian": "Sahkan pengeluaran",
    //goods-filter-tab
    "ZuiChangGouMai": "Kerap dibeli",
    "MoRenPaiXu": "Susunan lalai",
    "ZongHe": "Keseluruhan",
    "FenLei": "Kategori",
    "XiaoLiangYouXian": "Keutamaan jualan",
    "XiaoLiang": "Jualan",
    "JiaGe": "Harga",
    "ShaiXuan": "Tapis",
    "ZuiJinGouMai": "Beli-belah terkini",
    "CuXiaoYouXian": "Keutamaan promosi",
    "QuanBuFenLei": "Semua kategori",
    "ZhiKanCuXiao": "Hanya promosi",
    "XuanZeFenLei": "Pilih kategori",
    "QXZFL": "Sila pilih kategori",
    //goods-list-default
    "ZWXGSP": "Tiada produk berkaitan",
    //goods-brand-list
    "PinPaiHui": "Jenama",
    //goods-classify-filter
    "TuiJianFenLei": "Kategori disyorkan",
    "ShangPinFenLei": "Kategori produk",
    "GengDuo": "Lagi",
    //goods-detail
    "DLZHBSDQQY": "Akaun bukan pelanggan syarikat semasa",
    "GXNHQ": "Tahniah, anda dapat",
    "SZWSCJGH_C": "Tetapkan harga sebelum kongsi",
    "JHDJSHS_": "Baki masa:",
    "DLHKFX": "Log masuk untuk kongsi",
    "ZZHQXX_QSH": "Sedang mendapatkan maklumat",
    "Zhang": "keping",
    "Tian": "hari",
    "QXZGGZQPD": "Sila pilih spesifikasi dahulu",
    "Yuan": "RM",
    "XS_F_M": "jam/minit/saat",
    //integral
    "WoDeJiFen": "Mata ganjaran saya",
    "DaBaiLe": "Lebih baik daripada",
    "JiFen": "mata",
    "DeHuiYuan": "ahli",
    "ZhuanJiFen": "Dapatkan mata",
    "JiFenMingXi": "Butiran mata",
    "HuanLiPin": "Tukar hadiah",
    "CKGDHL": "Lihat lebih banyak hadiah",
    "ChaDingDan": "Semak pesanan",
    //integral-convert
    "DHSLBNCG": "Kuantiti penukaran tidak boleh melebihi",
    "DuiHuanShuLiang": "Kuantiti penukaran",
    "SuoXuJiFen": "Mata diperlukan",
    //integral-detail
    "LiPinXiangQing": "Butiran hadiah",
    "WoYaoDuiHuan": "Saya nak tukar",
    "ShengYu": "Baki",
    "TuWenXiangQing": "Butiran",
    "Jian": "unit",
    "YiDuiWan": "Habis",
    //integral-filter
    "FenLeiShaiXuan": "Tapis kategori",
    "JiFenShaiXuan": "Tapis mata",
    //integral-flow
    "JiFenShouRu": "Masuk mata",
    "JiFenZhiChu": "Keluar mata",
    //integral-logistics
    "DingDanGenZong": "Jejak pesanan",
    "WuLiuGongSi": "Syarikat logistik",
    "WuLiuDanHao": "No. resit",
    //integral-order
    "DingDanLieBiao": "Senarai pesanan",
    "YiFaHuo": "Telah dihantar",
    "JiFenDingDan": "Pesanan mata",
    "ChaKanWuLiu": "Lihat logistik",
    //integral-order-create
    "LPSLBZ_QCX": "Stok hadiah tidak cukup",
    "JiFenBuZu": "Mata tidak cukup",
    "ZhiFuXinXi": "Maklumat pembayaran",
    "JiXuGuangGuang": "Terus beli-belah",
    "QTXSHXX": "Sila isi maklumat penerimaan",
    "DuiHuanChengGong": "Penukaran berjaya",
    "LPDHQR": "Pengesahan penukaran hadiah",
    "SCCKJ": "Harga rujukan",
    "LiJiZhiFu": "Bayar segera",
    //integral-order-detail
    "DingDanXiangQing": "Butiran pesanan",
    "DingDanZhuangTai": "Status pesanan",
    "DingDanBianHao": "No. pesanan",
    "DuiHuanShiJian": "Masa penukaran",
    "ShouHuoXinXi": "Maklumat penerimaan",
    "HuaFeiJiFen": "Mata digunakan",
    //integral-rule
    "QDZJF": "Daftar masuk dapat mata",
    "XDZJF": "Buat pesanan dapat mata",
    "1_MRQD_JL": "1. Daftar masuk harian: +{num} mata",
    "2_LXQD3T_EW": "2. 3 hari berturut: +{num} mata",
    "3_LXQD7T_EW": "3. 7 hari berturut: +{num} mata",
    "DLZJF": "Log masuk dapat mata",
    "MRDLYSDHSC": "Log masuk harian: +{num} mata",
    "DDWCHKHDYD": "Lengkapkan pesanan: Mata = Nilai pesanan × {num}",
    //integral-rule-detail
    "GuiZe": "Peraturan",
    //integral-sign
    "QianDaoYouLi": "Daftar masuk dapat hadiah",
    "QianDaoGuiZe": "Peraturan daftar masuk",
    "YLXQD": "Daftar masuk berturut",
    "YLXQD1T": "Daftar masuk {num} hari",
    "QDCG_NYJLX": "Berjaya! Daftar masuk {num} hari",
    "QDCG_BCHD1": "Berjaya! Dapat {num} mata",
    "BCQDHD4JF_": "Dapat {num} mata, hebat!",
    "QSRBZ": "Sila masukkan catatan",
    "DingDanZengPin": "Hadiah pesanan",
    "GuiGeBianHao": "No. spesifikasi",
    "GuiGe": "Spesifikasi",
    //combined-pay
    "CDDWXFK": "Pesanan ini tidak perlu bayaran",
    "YHYEBZ": "Baki pengguna tidak cukup!",
    "ZFJEBNW0": "Jumlah pembayaran tidak boleh 0!",
    "ZFJEBNDYDD": "Jumlah melebihi tunggakan",
    "DFKJE": "Jumlah tunggakan",
    "FuKuanFangShi": "Kaedah pembayaran",
    "FuJian": "Lampiran",
    "ZHYFZ": "Akaun disalin",
    "GHSKZH": "Tukar akaun penerima",
    "SYXXZFQSCF": "Muat naik bukti pembayaran untuk pengesahan",
    "XXZF_BXXZS": "Pilih akaun penerima untuk pembayaran offline",
    "DingDanZhiFu": "Pembayaran pesanan",
    "ZFFS_HDFK": "Kaedah: Bayar upon delivery",
    "BCFKJE": "Jumlah pembayaran ini",
    "YuE": "Baki",
    "FuZhiZhangHao": "Salin akaun",
    "WSZXCXZFPZ": "Konfigurasi pembayaran tidak ditetapkan",
    "XCXZFZHJY": "Akaun pembayaran dinyahaktifkan",
    "SRZFJE": "Masukkan jumlah pembayaran",
    "FuKuanZhangHu": "Akaun pembayaran",
    "QueRenZhiFu": "Sahkan pembayaran",
    "ShaoHouZhiFu": "Bayar kemudian",
    //order
    "FKJLYTJ_DD": "Rekod pembayaran ditambah, tunggu semakan",
    "JiXuGuang": "Terus beli-belah",
    "BenCiFuKuan": "Pembayaran ini",
    "FuKuanChengGong": "Pembayaran berjaya",
    "ZhiFuFangShi": "Kaedah pembayaran",
    "ZhiFuDingDan": "Bayar pesanan",
    //order-batch-pay
    "QXXZSXZFDD": "Sila pilih pesanan untuk dibayar",
    "PiLiangFuKuan": "Pembayaran pukal",
    "FuKuan": "Bayar",
    "QuFuKuan": "Pergi bayar",
    //order-create-result
    "YingFuJinE": "Jumlah perlu bayar",
    "XiaDanShiJian": "Masa pesanan",
    //order-deliver
    "SFQRSH": "Sahkan penerimaan?",
    "DDQRSH": "Sahkan penerimaan pesanan",
    "DFHSP": "Produk menunggu penghantaran",
    "ShangPinShuLiang": "Bilangan produk",
    "ChuKuShiJian": "Masa keluar stok",
    "FaHuoShiJian": "Masa penghantaran",
    "WuLiuBeiZhu": "Catatan logistik",
    "QueRenShouHuo": "Sahkan penerimaan",
    "RYFK_QJSYG": "Hubungi admin jika sudah bayar",
    "QSRQXYY": "Sila masukkan sebab pembatalan",
    "H_DDJZDGB_QJKF": "Pesanan akan dibatalkan secara automatik",
    "TuiHuoQingKuang": "Status pulangan",
    "DingDanZongE": "Jumlah pesanan",
    "DingDanBeiZhu": "Catatan pesanan",
    "FaHuoQingKuang": "Status penghantaran",
    "DingDanFuJian": "Lampiran pesanan",
    "ShenQingTuiHuo": "Mohon pulangan",
    "G1TDSHJL_QRS": "Sahkan penerimaan {num} pesanan?",
    "DaiXiaDan": "Pesanan oleh ejen",
    "DingDanHao": "No. pesanan",
    "XiaDanFangShi": "Kaedah pesanan",
    "TuiHuoDan": "Pulangan",
    "ShangPinZongE": "Jumlah produk",
    "YunFei_ZongZhong": "Kos penghantaran (berat",
    "SF_SPWS": "Cukai (produk belum cukai",
    "TePiJia": "Harga khas",
    "FuKuanQingKuang": "Status pembayaran",
    "TiaoJiLu": "rekod",
    "ZaiLaiYiDan": "Buat pesanan sama",
    "MuLiuXinXi": "Maklumat logistik",
    "QDSCGDD_": "Sahkan padam pesanan?",
    "YiQueRen": "Telah disahkan",
    "YiShouHuo": "Telah diterima",
    "DaiFuJinE": "Jumlah tunggakan",
    "YiFuJinE": "Jumlah telah bayar",
    "ZanWuJiLu": "Tiada rekod",
    "SPMC_DDH": "Nama produk / No. pesanan",
    "FuKuanZhuangTai": "Status pembayaran",
    "FaHuoZhuangTai": "Status penghantaran",
    "QiShiShiJian": "Masa mula",
    "ZhongZhiShiJian": "Masa tamat",
    //order-list
    "CaoZuoChengGong": "Operasi berjaya",
    "ZBKGM": "Tidak boleh beli sekarang",
    "DQDDSPYXJ": "Produk dalam pesanan tidak dijual",
    "DQDDBFSPYXJ": "Sebahagian produk tidak dijual",
    "JTJSJSP": "Hanya tambah produk tersedia",
    "DingHuoDan": "Pesanan pembelian",
    //order-log
    "DingDanRiZhi": "Log pesanan",
    //order-logistics
    "FuZhiChengGong": "Salin berjaya",
    "FuZhiShiBai": "Salin gagal",
    "FuZhi": "Salin",
    "BoDa": "Dail",
    "WCWLDHXX": "Tiada maklumat logistik",
    //order-pay
    "ZFCS_QCXXD": "Masa pembayaran tamat, sila buat pesanan baru",
    "YQYYCKZF": "Pembayaran deposit diaktifkan",
    "BNDYDFKJE": "Tidak boleh melebihi tunggakan",
    "ZFJEBNWK": "Jumlah pembayaran diperlukan",
    "QXAPFK_FKH": "Sediakan bukti pembayaran untuk pengesahan",
    "DDTJCG_QJS": "Pesanan berjaya, sila bayar segera",
    "QXZFKFS": "Sila pilih kaedah pembayaran",
    "SYYEZFH_HX": "Selepas bayar dengan baki, perlu bayar lagi",
    "FuKuanJiLu": "Rekod pembayaran",
    "ZWFKJL": "Tiada rekod pembayaran",
    "FuKuanXiangQing": "Butiran pembayaran",
    "FuKuanJinE": "Jumlah pembayaran",
    "ZhiDan": "Dibuat oleh",
    "ShenHe": "Semak",
    "ZuoFei": "Batal",
    "ZuoFeiYuanYin": "Sebab pembatalan",
    "GLDHD": "Pesanan berkaitan",
    "HeXiaoJinE": "Jumlah disahkan",
    "HeXiaoZhuangTai": "Status pengesahan",
    "DanJuZhuangTai": "Status dokumen",
    "KeHuMingCheng": "Nama pelanggan",
    "ZhangDanHao": "No. bil",
    "ShouKuanZhangHao": "Akaun penerima",
    "ShouKuanShiJian": "Masa penerimaan",
    "FuKuanPingZheng": "Bukti pembayaran",
    "GeFuJian": "lampiran",
    //order-statistics
    "DingDanTongJi": "Statistik pesanan",
    "DingHuo0Bi": "{num} pesanan",
    //order-statistics-detail
    "DDTJMX": "Butiran statistik",
    "AGGTJ": "Mengikut spesifikasi",
    "AFLTJ": "Mengikut kategori",
    "DDJE_Y": "Jumlah pesanan/RM",
    "DHSP_Z": "Produk pesanan/jenis",
    "DingHuoDan_Bi": "Pesanan/bil",
    "DingHuoShangPin": "Produk pesanan",
    "JinE": "Jumlah",
    //refund-list
    "TuiHuo": "Pulangan",
    //refund-apply
    "THDHWBC_QD": "Pulangan belum disimpan, keluar?",
    "QSRSQTHJE": "Sila masukkan jumlah pulangan",
    "QSRTHJE": "Sila masukkan jumlah pulangan",
    "QSRBZXX": "Sila masukkan catatan",
    "YingTuiJinE": "Jumlah patut dipulangkan",
    "TJTHSQ": "Hantar permohonan pulangan",
    "QXXZDHQD": "Sila pilih senarai pesanan",
    "DingHuoQingDan": "Senarai pesanan",
    "SQTHJE": "Jumlah permohonan pulangan",
    "DJXZSP": "Klik pilih produk",
    "TuiHuoJinE": "Jumlah pulangan",
    //refund-detail
    "THDDXQ": "Butiran pulangan",
    "YiTuiHuo": "Telah dipulangkan",
    "YiTuiKuan": "Telah dibayar balik",
    "THDZT": "Status pulangan",
    "TuiHuoDanHao": "No. pulangan",
    "TuiHuoShiJian": "Masa pulangan",
    "TuiHuoCangKu": "Gudang pulangan",
    "THLXR": "Orang hubungan pulangan",
    "TuiHuoQingDan": "Senarai pulangan",
    "TuiKuanZongE": "Jumlah bayaran balik",
    "TuiKuanQingKuang": "Status bayaran balik",
    "DaiTuiJinE": "Jumlah tunggakan",
    "YiTuiJinE": "Jumlah telah dibayar balik",
    //refund-product
    "SPMC_BH_GG": "Nama produk / No. / Spesifikasi / Kod bar",
    "GZD1TJG": "1 keputusan dijumpai",
    "JiaRuQingDan": "Tambah ke senarai",
    //refund-result
    "ShenQingChengGong": "Permohonan berjaya",
    "THDTJCG": "Pulangan berjaya dihantar",
    "ChaKanXiangQing": "Lihat butiran",
    //goods-package-floor
    "HDWKS_WDZL": "Aktiviti belum bermula",
    "HDYJS_XCZD": "Aktiviti tamat",
    "ZWSZBT": "Tiada tajuk",
    "ChaKanGengDuo": "Lihat lagi",
    //goods-promotion-floor
    "HCDZSJC": "Perbezaan masa disebabkan cache",
    "DLCKCXJ": "Log masuk untuk lihat harga promosi",
    "ZWSZCX": "Tiada promosi",
    "JuKaiShi": "Sebelum bermula",
    "Song": "Hadiah",
    "JuJieShu": "Sebelum tamat",
    "YiJieShu": "Telah tamat",
    //search-floor
    "XiaoXi": "Mesej",
    "SaoMaXiaDan": "Pesan dengan imbas",
    //home-page-custom
    "WZLCSJ": "Data tidak diketahui",
    //jump-error
    "QXZYSDHAPP": "Muat turun APP YUNSHANG",
    "QMTYQYGLD": "Pengalaman penuh pengurusan",
    "XZYSDHAPP": "Muat turun APP YUNSHANG",
    "HQGLDWZTY": "Dapatkan pengalaman penuh",
    "JXTYDHD": "Teruskan dengan pesanan",
    //notice-detail
    "GongGaoXiangQing": "Butiran pengumuman",
    "GongGaoFuJian": "Lampiran pengumuman",
    //shop-error
    "NFWDYMBCZO": "Halaman tidak dijumpai",
    "KeNengYuanYin": "Sebab mungkin",
    "1_ZDZLSRCWD": "1. URL salah",
    "2_DJLGQLJ": "2. Pautan tamat tempoh",
    //shop-index
    "GuanLiDuan": "Pentadbiran",
    "ZhuCe": "Daftar",
    "HYNTYYSDH": "Selamat datang ke YUNSHANG",
    "TYZHSJHDQG": "Data akaun percubaan akan dikemas kini",
    "TYZHZDNRSJ": "Data dalam akaun percubaan adalah simulasi",
    "ZHZCCG": "Pendaftaran berjaya",
    "DengLuZhangHao": "Akaun log masuk",
    "CSMMW": "Kata laluan lalai",
    "GNFYHQL": "Anda dapat kupon",
    "Man1YuanKeYong": "Min {num}RM boleh digunakan",
    "LQH1TNKY": "Sah {day} hari",
    "YiJianLingQu": "Dapatkan segera",
    "GXNHD1ZYHQ": "Tahniah, anda dapat {num} kupon {price}RM {name}",
    "Gong1Yuan": "Jumlah {num}RM",
    "LiJiShiYong": "Guna segera",
    //shop-login
    "NHWDL": "Anda belum log masuk",
    //shop-notice
    "ShangChengGongGao": "Pengumuman kedai",
    "ZanWuGongGao": "Tiada pengumuman",
    "1GeFuJian": "{num} lampiran",
    //deposit-detail
    "KouKuan": "Debit",
    "ChongZhi_Kuan": "Isi semula",
    "KouKuanZuoFei": "Debit dibatalkan",
    "ChongZhiZuoFei": "Isi semula dibatalkan",
    "ZhangHuMingXi": "Butiran akaun",
    "ZhangHuYuE": "Baki akaun",
    "LiJiChongZhi": "Isi semula segera",
    //deposit-recharge
    "CZJEBNXY1Y": "Jumlah isi semula minimum RM1",
    "QSRZQDSZ": "Sila masukkan nilai sah",
    "ZDYJE": "Jumlah tersuai",
    "ZWKTXSCZGN": "Isi semula online tidak tersedia",
    "ShiFuJinE": "Jumlah sebenar",
    "ZhangHuChongZhi": "Isi semula akaun",
    "QXZCZJE": "Pilih jumlah isi semula",
    "QSRCZJE": "Masukkan jumlah isi semula",
    "QLXNDZSYWY": "Hubungi wakil jualan",
    "ShouJia": "Harga jualan",
    "YiShouQing": "Habis dijual",
    "ChongZhiJinE": "Jumlah isi semula",
    "QueRenFuKuan": "Sahkan pembayaran",
    //deposit-recharge-result
    "QSDDID": "Tiada ID pesanan",
    "ChongZhiChengGong": "Isi semula berjaya",
    "ChongZhiShiBai": "Isi semula gagal",
    "CLZ_QSH...": "Memproses, sila tunggu...",
    "ChongZhiFangShi": "Kaedah isi semula",
    "ChongZhiShiJian": "Masa isi semula",
    "JYLSH": "No. transaksi",
    "FanHuiShangCheng": "Kembali ke kedai",
    //recharge-online
    "ZFSB_QCS": "Pembayaran gagal, cuba lagi",
    "ZFYQX": "Pembayaran dibatalkan",
    "ZFYC_QCS": "Ralat pembayaran, cuba lagi",
    //user
    "LingQuanZhongXin": "Pusat kupon",
    "WeiShiYong": "Belum digunakan",
    "YiShiYong": "Telah digunakan",
    "ZWYHQ": "Tiada kupon",
    //keep-list
    "YiGouMai": "Telah dibeli",
    "ChangYongQingDan": "Senarai kerap",
    "WoDeShouCang": "Kegemaran saya",
    "QuGouWuChe": "Ke troli",
    "GeShangPin": "produk",
    //login
    "YunShangDingHuo": "YUNSHANG",
    "QSRZH": "Sila masukkan akaun!",
    "QSRMM": "Sila masukkan kata laluan!",
    "QSRDLZH": "Sila masukkan akaun log masuk",
    "JiZhuMiMa": "Ingat kata laluan",
    "WangJiMiMa": "Lupa kata laluan?",
    "DengLu": "Log masuk",
    "DLZHBCZ_QL": "Akaun tidak wujud, hubungi admin",
    "GQYZHSBJY_": "Akaun syarikat dinyahaktifkan",
    "GQYZHSYQJS_": "Tempoh percubaan tamat",
    "GQYZHYGQL_": "Akaun tamat tempoh, perlu diperbaharui",
    "LiJiTiYan": "Cuba sekarang",
    //my-collect
    "YiChuChengGong": "Alih keluar berjaya",
    "QueHuo": "Stok habis",
    "YCSCJ": "Alih keluar dari kegemaran",
    //order-message
    "SheZhiChengGong": "Tetapan berjaya",
    "ZWWDXX": "Tiada mesej belum baca",
    "QuanBuYiDu": "Tanda semua sebagai dibaca",
    "DingDanXiaoXi": "Mesej pesanan",
	"YiQiang": "Telah diambil",
"LiJiLingQu": "Dapatkan segera",
"LingQuanHou": "Selepas menerima kupon",
"TianNeiKeYong": "boleh digunakan dalam {n} hari",
"QSRSJH": "Masukkan nombor telefon",
"QSRYZM": "Masukkan kod pengesahan",
"QSRXMM": "Masukkan kata laluan baru",
"QSRZQSJGS": "Masukkan format telefon yang betul",
"ChongZhiMiMa": "Tetapkan semula kata laluan",
"QSRNDSJHM": "Masukkan nombor telefon anda",
"QSRDXYZ": "Masukkan kod SMS",
"HQYZM": "Dapatkan kod",
"HKCXHQ": "Hantar semula dalam {n}",
"QSR6_20WSZHZ": "Kata laluan: 6-20 aksara (nombor/huruf)",
    //share-setting
    "QSRSPJGBL": "Sila masukkan nisbah harga produk",
    "SPJGBLBXDY": "Nisbah mesti antara 100-999.99",
    "DPMCZBZCTS": "Nama kedai tidak menyokong aksara khas",
    "LXRZBZCTSF": "Nama hubungan tidak menyokong aksara khas",
    "LXFSZBZCTS": "Maklumat hubungan tidak menyokong aksara khas",
    "LXDZZBZCTS": "Alamat tidak menyokong aksara khas",
    "DPJJZBZCTS": "Penerangan kedai tidak menyokong aksara khas",
    "QSRDPJJ_ZD": "Sila masukkan penerangan kedai (maks 50 aksara)",
    "FenXiangSheZhi": "Tetapan kongsi",
    "NDWSCSPJG": "Harga produk anda",
   "NDDHJ_": "Harga pesanan anda ×",
    "LXXX_KBJ_": "Maklumat hubungan (boleh diedit)",
    "DianPuMingCheng": "Nama kedai",
    "JianJie": "Pengenalan",
    "QSRDPMC": "Sila masukkan nama kedai",
    "LianXiRen": "Orang hubungan",
    "QSRLXR": "Sila masukkan nama orang hubungan",
    "LianXiFangShi": "Cara hubungan",
    "QSRLXFS": "Sila masukkan maklumat hubungan",
    "LianXiDiZhi": "Alamat hubungan",
    "QSRLXDZ": "Sila masukkan alamat hubungan",
    //user
    "WoDeDingDan": "Pesanan saya",
    "ZuiJinLiuLan": "Baru dilihat",
    "ShouCangShangPin": "Produk disimpan",
    "BDYYZH_ZC": "Ikut akaun sedia ada | Daftar akaun baru",
    "DL_ZC": "Log Masuk | Daftar",
    "BangDingShouJi": "Ikat nombor telefon",
    "TS_BDSJHM_": "Petua: Ikat nombor telefon untuk keselamatan akaun!",
    "ChaKanQuanBu": "Lihat semua",
    "ShouHuoDiZhi": "Alamat penghantaran",
    "LianXiWoMen": "Hubungi kami",
    "SheZhi": "Tetapan",
    "QuQianDao": "Pergi daftar masuk",
    "QianDao": "Daftar masuk",
    "JiFenShangCheng": "Kedai mata ganjaran",
    "TuiGuangShangPin": "Promosi produk",
    "QuChaKan": "Pergi lihat",
    "JiFenHuanLi": "Tukar mata ganjaran",
    "DYSPBQ": "Cetak label produk",
    //user-about
    "GYYSDH": "Mengenai YUNSHANG",
    "YQHYSMEWM_": "Jemput rakan imbas kod QR untuk muat turun",
    "DangQianBanBen": "Versi semasa",
    //user-address
    "ZWSHDZ": "Tiada alamat penghantaran",
    "WoDeDiZhi": "Alamat saya",
    "ZhiNengShiBie": "Pengecaman pintar",
    "ZTDZXXKZNS": "Tampal maklumat alamat untuk pengecaman automatik",
    "MoRen": "Lalai",
    "QRSCDZ": "Sahkan padam alamat?",
    "SHRXM": "Nama penerima",
    "SJHMHGDDHZ": "Nombor telefon atau talian tetap diperlukan",
    "QSRSHRXM": "Sila masukkan nama penerima",
    "ShouJiHaoMa": "Nombor telefon",
    "GuDingDianHua": "Talian tetap",
    "QSRGDDH": "Sila masukkan nombor talian tetap",
    "SuoZaiDiQu": "Kawasan",
    "QSRSZDQ": "Sila masukkan kawasan",
    "QSRXXDZ": "Sila masukkan alamat terperinci!",
    "QSRZQDSJHM": "Sila masukkan nombor telefon yang sah",
    "QSRZQDGDDH": "Sila masukkan nombor talian tetap yang sah",
    "XiangXiDiZhi": "Alamat terperinci",
    "MoRenDiZhi": "Alamat lalai",
    "SWMRDZ": "Tetapkan sebagai lalai",
    "BCBSY": "Simpan & gunakan",
    //user-bing-one
    "QSRSJHM": "Sila masukkan nombor telefon",
    "GYHYZC": "Pengguna ini sudah berdaftar",
    "GSJHMYJZCG": "Nombor telefon sudah berdaftar",
    "QZJDLJK": "Sila log masuk terus",
    "QuDengLu": "Pergi log masuk",
    "BDHKYTGSJH": "Ikat untuk log masuk dengan nombor telefon",
    "_BDHKYTGSJ": "*Ikat untuk log masuk dengan nombor telefon",
    "QSRSJYZM": "Sila masukkan kod pengesahan SMS",
    "BDXSJ": "Ikat nombor telefon baru",
    "DXYZM": "Kod pengesahan SMS",
    "XiaYiBu": "Seterusnya",
    "TGCBZ": "Langkau langkah ini",
    //user-bing-two
    "DBDSJHMBCZ": "Nombor telefon belum diikat!",
    "QSRDLMM": "Sila masukkan kata laluan!",
    "_GSJHMYBDY": "*Nombor telefon sudah diikat",
    "DQZHMMJTBW": "Kata laluan akan diselaraskan",
    "DangQianZhangHao": "Akaun semasa",
    "QDYJZ": "Sahkan padam",
    "JSPSCM": "produk ini?",
    "ShanChuChengGong": "Padam berjaya!",
    //user-info
    "SJGSCW": "Format nombor telefon salah",
    "YXGSCW": "Format emel salah",
    "WoDeZhangHao": "Akaun saya",
    "YouXiang": "Emel",
    "ShouJi": "Telefon",
    "XingMing": "Nama penuh",
    "XiuGaiTouXiang": "Tukar gambar profil",
    "JiBenXinXi": "Maklumat asas",
    "ZhangHaoAnQuan": "Keselamatan akaun",
    "XiuGaiMiMa": "Tukar kata laluan",
    "DianJiBangDing": "Klik untuk ikat",
    "RYDSHTY_QL": "Jika hilang atau tidak digunakan, tukar segera",
    "WBZNDZHAQ_": "Ikat nombor telefon untuk keselamatan",
	"QSRNDXM": "Nhập họ tên của bạn",
    "QSRNDDH": "Nhập số điện thoại",
    "QSRNDYX": "Nhập email",
    //user-setting
    "QCHCHXCXDL": "Kosongkan cache memerlukan log masuk semula",
    "QingChuHuanCun": "Kosongkan cache",
    "QDYQCHCM": "Sahkan kosongkan cache?",
    "TuiChuDengLu": "Log keluar",
    "ZhangHaoZhuXiao": "Nyahdaftar akaun",
    "QieHuanZhangHao": "Tukar akaun",
    //user-supplier
    "LianXi": "Hubungi",
    "GongSiDianHua": "Telefon syarikat",
    "DiZhi": "Alamat",
    //vouchers-detail
    "DJQMX": "Butiran baucar",
    //vouchers-list
    "BuKeYong": "Tidak boleh digunakan",
    "KeYong": "Boleh digunakan",
    "ZWDJQ": "Tiada baucar",
    "ZongEDu": "Jumlah nilai",
    "FaFangShiJian": "Masa pengeluaran",
    "EDYYW": "Nilai sudah habis",
    //vouchers-select-list
    "WDDJQ": "Baucar saya",
    "KYDJQ": "Baucar boleh digunakan",
    "DJQKDK": "Baucar boleh potong",
    "CKKYSP": "Lihat produk tersedia",
    "BKYDJQ": "Baucar tidak boleh digunakan",
    "BKYYY_ZWFH": "Sebab: Tiada produk memenuhi syarat",
    //goods-detail
    "DQSPWSCGGT": "Produk ini tiada gambar spesifikasi",
    "BoFangShiPin": "Main video",
    "Gong1GeGuiGe": "Jumlah {num} spesifikasi",
    "YiXuanGuiGe": "Spesifikasi dipilih",
    "XuanGuiGe": "Pilih spesifikasi",
    "LingQuan": "Dapatkan kupon",
    "1ZhongCuXiao": "{num} promosi",
    "1ZhangKeYong": "{num} boleh digunakan",
    "ZuiGaoKeSheng": "Penjimatan maksimum",
    "ShangPinTaoCan": "Pakej produk",
    "Gong1GeTaoCan": "Jumlah {num} pakej",
    "ShangPinCanShu": "Spesifikasi produk",
    "ZhanKai": "Kembangkan",
    "YiShouCang": "Disimpan",
    "ShouCang": "Simpan",
    "KeFu": "Khidmat pelanggan",
    "XiangQing": "Butiran",
    "TuiJian": "Disyorkan",
    "BianHao": "Nombor",
    "ShangPinXinXi": "Maklumat produk",
    "KLYHQ": "Kupon boleh diperolehi",
    "KuCunBuZu": "Stok tidak cukup",
    "DuoGuiGe": "Pelbagai spesifikasi",
    "YiShou": "Terjual",
    "SWBHZ_YS": "Stok habis, terjual",
    "CuXiaoShangPin": "Produk promosi",
    //goods-search
    "NHWSRSSNR": "Anda belum memasukkan carian",
    "SouSuo": "Cari",
    "SSY1XGDSP": "Cari produk berkaitan {searchKey}",
    "Yue1GeShangPin": "Lebih kurang {num} produk",
    "ZuiJinSouSuo": "Carian terkini",
    "QingChu": "Kosongkan",
    "ZWSSJL": "Tiada rekod carian",
    //goods-property
    "ZGJGBNDYZD": "Harga maksimum tidak boleh lebih rendah",
    "ShangPinBiaoQian": "Tag produk",
    "BuGaoYu1": "Tidak lebih tinggi daripada 1",
    "BuDiYu1": "Tidak lebih rendah daripada 1",
    "FengGe": "Gaya",
    //goods-promotion-list
    "JiJiangKaiShi": "Akan bermula",
    "QuanBuCuXiao": "Semua promosi",
    //goods-package-list
    "Gong1JianShangPin": "Jumlah {num} produk",
    "Sheng": "Jimat",
    //goods-package-detail
    "GTCZGWCZDS": "Pakej ini mencapai had dalam troli",
    "GTCKCBZ_BK": "Stok pakej tidak cukup",
    "JinSheng1Tao": "Hanya tinggal {num} set",
    "XianGou1Tao": "Had pembelian {num} set",
    "TaoCanXiangQing": "Butiran pakej",
    "DanMaiJia": "Harga unit",
    "TaoCanJia": "Harga pakej",
    "HDYJS": "Promosi tamat",
    //goods-message
    "WDL_QXDL": "Belum log masuk, sila log masuk",
    //goods-list-label
    "XinPinShangShi": "Produk baru",
    "WDLZH_ZWCX": "Belum log masuk, tiada promosi",
    "YiXiaShangPin": "Produk berikut",
    //goods-list
    "1ZhongGuiGe": "{num} spesifikasi",
    "YouKuCun": "Ada stok",
    //goods-filter
    "BuGaoYu": "Tidak lebih tinggi daripada",
    "BuDiYu": "Tidak lebih rendah daripada",
    "CuXiao": "Promosi",
    "ZDYXXZ3G": "Maksimum pilih 3",
    "GouMai": "Beli",
    "Gong1Jian": "Jumlah {num} unit",
    //缺失
    "YiChuShouCangJia": "Alih keluar dari simpanan",
    "$": "RM",
    "$1": "RM{num}",
    "_8999_1Qi": "Dari RM 8999.1",
    "Ge": "unit",
    "BaoZhuangFangShi": "Cara pembungkusan",
    "QRSCSP_": "Sahkan padam produk?",
    "JEWM_TMFRK": "Imbas kod QR/kod bar",
    "0ZSP_G0J": "0 jenis produk, 0 unit",
    "JiuMiMa": "Kata laluan lama",
    "XMM_6_20WZ": "Kata laluan baru (6-20 aksara)",
    "QueRenMiMa": "Sahkan kata laluan",
    "BDHKSYSJHD": "Ikat untuk log masuk dengan nombor telefon",
    "YanZhengMa": "Kod pengesahan",
    "1MHKCXHQ": "Cuba semula dalam 1 saat",
    "CSJHZ1MQFS": "Kod sudah dihantar, cuba sebentar lagi",
    "GouMaiJiLu": "Rekod pembelian",
    "XinZengDiZhi": "Tambah alamat baru",
    "LingShouJia": "Harga runcit",
    "YouHuiJia": "Harga promosi",
    "ShangPinChuKu": "Produk keluar stok",
    "DengDaiShouHuo": "Menunggu penghantaran",
    "ShouHuoRen": "Penerima",
    "PaiZhao": "Ambil gambar",
    "XiangCe": "Galeri",
    "TiYanGuan": "Galeri pameran",
    "JingYingShiJian": "Waktu operasi",
    "ZhanGuanDianHua": "Telefon galeri",
    "ZhanGuanDiZhi": "Alamat galeri",
    "SJHQZ_QSDZ": "Sedang memuat, cuba sebentar lagi",
    "QXXZSF_": "Sila pilih wilayah dahulu!",
    "QuanBuShengFen": "Semua wilayah",
    "QuanBuChengShi": "Semua bandar",
    "YingYeShiJian": "Waktu operasi",
    "ChanPinBianHao": "Nombor produk",
    "DLXXYGQ_QC": "Sesi tamat, sila log masuk semula",
    "Man999Jian100": "Beli {m} jimat {n}",
    "YiManZu": "Telah memenuhi",
    "QDYCSP_": "Sahkan alih keluar produk?",
    "DGM10JZ1J": "Beli 10 dapat 1 percuma",
    "XiaXianTongZhi": "Notifikasi offline",
    "NDZHYZQTSB": "Akaun anda log masuk di peranti lain",
    "ManJiang": 'Beli {target} jimat {num}',
    "ZGLXMJ": 'Beli {num} lagi jimat {money_}',
    "ZGLXMZ": 'Beli {num} lagi dapat {percent}% diskaun',
    "QSRZQNR": 'Sila masukkan kandungan yang betul',
    "NHYDDQKWJQ": 'Anda ada {num} pesanan belum selesai',
    "FaPiaoZhuShou": "Pembantu invois",
    "WoDeFaPiao": "Invois saya",
    "FaPiaoXiangQing": "Butiran invois",
    "KaiPiaoShiJian": "Masa keluaran invois",
    "DaiKaiFaPiao": "Invois belum dikeluarkan",
    "DKFPJE": "Nilai invois belum dikeluarkan",
    "KaiPiaoJinE": "Nilai invois",
    "ZFYDWT_QCSCXZF": "Masalah pembayaran, cuba kaedah lain",
    "QingXuanZhe": "Sila pilih",
    "ShouXin":'Kredit',
    "LJSQSXED":"Mohon kredit sekarang",
    "SXEDSHZ":"Kredit dalam semakan",
    "SXCZ_XDCG": "Kredit mencukupi, pesanan berjaya",
    "SXEDBZ_FKHFH": "Kredit tidak cukup, bayar sebelum hantar",
    "CGJKZQ_FKFH": "Lewat tempoh, bayar sebelum hantar",
    "DDTJCG_XZZCZHYB": "Pesanan berjaya, tinggal langkah terakhir!",
    "MianFeiLing": "Dapatkan percuma",
    "M_KMFLQ_HQ": "Beli {target} dapat percuma, kurang {short}",
    "YHDMFSP": "Sudah dapat produk percuma",
    "JRMFL": "Percuma hari ini",
    "LingGuangLe": "Habis",
    "KeLingQu": "Boleh dapat",
    "YuGuJia": "Anggaran harga",
    "GXNHQ_Z_Y_": "Tahniah, anda dapat {num} kupon {price}RM {name}",
    "LXZSKF": "Hubungi wakil jualan",
    "DPYDY_QSHX": "Kedai tutup, sila pesan nanti",
    "DaYangShiJian": "Waktu tutup",
    "ChuanHaoChaXun": 'Semak nombor siri',
    'IMEI': 'Nombor siri',
    "FanKuanYuE":"Baki rebat",
    "FanKuanZhiFu":"Bayar dengan rebat",
    "JingDongYiYunJia":"Jingdong Yiyun+",
    "MercadoPago":"MercadoPago",
    "FKYEBZ":"Baki rebat tidak cukup",
    "FanKuanZhangHu": "Akaun rebat",
    "HaiXuZhiFu": "Perlu bayar lagi {price}",
    "QTXGSMC":"Sila masukkan nama syarikat",
    "QSCSFZZMZ":"Sila muat naik kad pengenalan hadapan",
    "QSCSFZFMZ":"Sila muat naik kad pengenalan belakang",
    "QSCYYZZ":"Sila muat naik lesen perniagaan",
    "TJCG_QNXDDSH":"Hantar berjaya, tunggu semakan",
    "SXSQ":"Permohonan kredit",
    "QYJBZL":"Maklumat asas syarikat",
    "SQFRSFZZM":"Muat naik kad pengenalan hadapan",
    "ZMSLT":"Contoh hadapan",
    "SCFRSFZFM":"Muat naik kad pengenalan belakang",
    "FMSLT":"Contoh belakang",
    "QQBSFZSJWZ_WZQXKBB":"Pastikan kad pengenalan jelas",
    "SCYYZZ":"Muat naik lesen perniagaan",
    "ShengHeZhong":"Dalam semakan",
    "TiJiaoShenHe":"Hantar untuk semakan",
    "GSMC":"Nama syarikat",
    "DDDKFQRBJQSH":"Pesanan menunggu pengesahan harga",
    "XDTX":"Peringatan pesanan",
    "NH_GDDBH":"Sesetengah produk perlu pengesahan harga",
    "QRXD":"Sahkan pesanan",
    "DaiHeJia":"Menunggu pengesahan harga",
    "ZHJY":"Baki akaun",
    "YGTG":"Promosi pekerja",
    "YuanGong":"Pekerja",
    "DuiZhanGJieSuan":"Penyelesaian akaun",
    "ZHJY_YCKYE_FKYE_THDTK_DDYFK":"Baki = Deposit + Rebate + Pulangan belum bayar - Belum bayar",
    "YCKYE":"Baki deposit",
    "FKYE":"Baki rebat",
    "DDYFK":"Belum bayar",
    "THDTK":"Pulangan belum bayar",
    "YuCunKuanZuoFei":"Deposit terbatal",
    "FanKuanZhangHuMingXi":"Butiran akaun rebat",
    "TKCZDFKZH":"Isi semula ke akaun rebat",
    "RMBJE":"Jumlah RMB",
};
export default ms_MY



// WEBPACK FOOTER //
// ./src/locale/ms_MY.js